<template>
   <section>
     <div class="main-contents-wrapper">
      <h1 style="font-size:30px; padding: 10px 0;">DASHBOARD</h1>
      <p class="dashtext">{{ $t('txt.dashA') }}<br />{{ $t('txt.dashB') }}</p>
      <p v-if="loading" class="dashboard-status" role="status">대시보드를 불러오는 중입니다.</p>
      <div v-else-if="loadError" class="dashboard-status" role="alert">
        대시보드를 불러오지 못했습니다.
        <button type="button" @click="loadData">다시 시도</button>
      </div>
      <p v-else-if="!hasSummary" class="dashboard-status" role="status">아직 집계된 내역이 없습니다. 내역이 쌓이면 자동으로 표시됩니다.</p>
       <div v-if="!loadError" class="dashwrap" :aria-busy="loading">
          <ul class="dashth">
             <li class="inout">
                <!-- <em class="bgrd"><img src="@/assets/img/icon_cost.svg" /></em> -->
                <ul class="dashlist">
                  <li>{{ $t('table.head.inAmt') }}
                    <span>￦{{dashInfo[0].inCashAmt < 0 ? '-' : ''}}{{ dashInfo[0].inCashAmtStr }}</span>
                  </li>
                  <li>{{ $t('table.head.preDate') }}
                    <span>{{ $t('table.head.preDate') }} {{ $t('table.head.inAmt') }}</span>
                    <span>￦{{dashInfo[1].inCashAmt < 0 ? '-' : ''}}{{ dashInfo[1].inCashAmtStr }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.body.diff') }}</span>
                    <span>￦{{diffDashInfo.inCashAmt < 0 ? '-' : ''}}{{ diffDashInfo.inCashAmtStr }}</span>
                  </li>
                </ul>
             </li>
             <li class="inout">
                <!-- <em class="bgrd"><img src="@/assets/img/icon_cost.svg" /></em> -->
                <ul class="dashlist">
                  <li>{{ $t('table.head.outAmt') }}
                    <span>￦{{dashInfo[0].outCashAmt < 0 ? '-' : ''}}{{ dashInfo[0].outCashAmtStr }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.head.preDate') }} {{ $t('table.head.outAmt') }}</span>
                    <span>￦{{dashInfo[1].outCashAmt < 0 ? '-' : ''}}{{ dashInfo[1].outCashAmtStr }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.body.diff') }}</span>
                    <span>￦{{diffDashInfo.outCashAmt < 0 ? '-' : ''}}{{ diffDashInfo.outCashAmtStr }}</span>
                  </li>
                </ul>
             </li>
             <li class="inout">
                <!-- <em class="bgrd"><img src="@/assets/img/icon_cost.svg" /></em> -->
                <ul class="dashlist">
                  <li>{{ $t('table.head.profit') }}
                    <span>￦{{dashInfo[0].beneAmt < 0 ? '-' : ''}}{{ dashInfo[0].beneAmtStr }}</span>
                  </li>                  
                  <li>
                    <span>{{ $t('table.head.preDate') }} {{ $t('table.head.profit') }}</span>
                    <span>￦{{dashInfo[1].beneAmt < 0 ? '-' : ''}}{{ dashInfo[1].beneAmtStr }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.body.diff') }}</span>
                    <span>￦{{diffDashInfo.beneAmt < 0 ? '-' : ''}}{{ diffDashInfo.beneAmtStr }}</span>
                  </li>
                </ul>
             </li>
             <li class="new">
                <!-- <em class="bggn"><img src="@/assets/img/icon_nuser.svg" /></em> -->
                <ul class="dashlist">
                  <li>{{ $t('txt.newNumSub') }}
                    <span>{{dashInfo[0].memJoinCntStr}} {{ $t('common.person') }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.head.preDate') }} {{ $t('txt.numSub') }}</span>
                    <span>{{dashInfo[1].memJoinCntStr}} {{ $t('common.person') }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.body.difft') }}</span>
                    <span> {{ diffDashInfo.memJoinCntStr }} {{ $t('common.case') }}</span>
                  </li>
                </ul>
             </li>
          </ul>
          <ul class="dashth">
             <li class="bet">
                <!-- <em class="bgyw"><img src="@/assets/img/icon_cost.svg" /></em> -->
                <ul class="dashlist">
                  <li>{{ $t('table.head.betAmt') }}
                    <span>￦{{dashInfo[0].betAmt < 0 ? '-' : ''}}{{ dashInfo[0].betAmtStr }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.head.preDate') }} {{ $t('table.head.betAmt') }}</span>
                    <span>￦{{dashInfo[1].betAmt < 0 ? '-' : ''}}{{ dashInfo[1].betAmtStr }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.body.diff') }}</span>
                    <span>￦{{diffDashInfo.betAmt < 0 ? '-' : ''}}{{ diffDashInfo.betAmtStr }}</span>
                  </li>
                </ul>
             </li>
             <li class="bet">
                <!-- <em class="bgyw"><img src="@/assets/img/icon_cost.svg" /></em> -->
                <ul class="dashlist">
                  <li>{{ $t('table.head.winAmt') }}
                    <span>￦{{dashInfo[0].winAmt < 0 ? '-' : ''}}{{ dashInfo[0].winAmtStr }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.head.preDate') }} {{ $t('table.head.winAmt') }}</span>
                    <span>￦{{dashInfo[1].winAmt < 0 ? '-' : ''}}{{ dashInfo[1].winAmtStr }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.body.diff') }}</span>
                    <span>￦{{diffDashInfo.winAmt < 0 ? '-' : ''}}{{ diffDashInfo.winAmtStr }}</span>
                  </li>
                </ul>
             </li>
             <li class="bet">
                <!-- <em class="bgyw"><img src="@/assets/img/icon_cost.svg" /></em> -->
                <ul class="dashlist">
                  <li>{{ $t('table.head.wl') }}
                    <span>￦{{dashInfo[0].winLoseAmt < 0 ? '-' : ''}}{{ dashInfo[0].winLoseAmtStr }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.head.preDate') }} {{ $t('table.head.wl') }}</span>
                    <span>￦{{dashInfo[1].winLoseAmt < 0 ? '-' : ''}}{{ dashInfo[1].winLoseAmtStr }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.body.diff') }}</span>
                    <span>￦{{diffDashInfo.winLoseAmt < 0 ? '-' : ''}}{{ diffDashInfo.winLoseAmtStr }}</span>
                  </li>
                </ul>
             </li>
             <li class="new">
                <!-- <em class="bggn"><img src="@/assets/img/icon_bet.svg" /></em> -->
                <ul class="dashlist">
                  <li>{{ $t('txt.newNumBet') }}
                    <span>{{dashInfo[0].betCntStr}} {{ $t('common.case') }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.head.preDate') }} {{ $t('txt.numBet') }}</span>
                    <span>{{dashInfo[1].betCntStr}} {{ $t('common.case') }}</span>
                  </li>
                  <li>
                    <span>{{ $t('table.body.difft') }}</span>
                    <span> {{ diffDashInfo.betCntStr }} {{ $t('common.case') }}</span>
                  </li>
                </ul>
             </li>
          </ul>
          <!-- <ul class="dashth">
             <li>
                <em class="bgbl"><img src="@/assets/img/icon_insure.svg" /></em>
                <a class="open"><img src="@/assets/img/icon_open.svg" /></a>
                <ul class="dashlist">
                   <li>
                      <span>{{ $t("common.credit") }}</span>
                      <span>-</span>
                   </li>
                   <li>
                      <span>POINT</span>
                      <span>-</span>
                   </li>
                   <li class="btnwrap">
                      <a @click="modalOpen('apply')">알 신청</a>
                      <a @click="modalOpen('exchange')">알 환전</a>
                   </li>
                </ul>
             </li>
             <li>
                <em class="bgbl"><img src="@/assets/img/icon_insure.svg" /></em>
                <a class="open"><img src="@/assets/img/icon_open.svg" /></a>
                <ul class="dashlist">
                   <li>
                      <span>보험</span>
                      <span>-</span>
                   </li>
                   <li>
                      <span>POINT</span>
                      <span>-</span>
                   </li>
                   <li class="btnwrap">
                      <a @click="modalOpen2('apply')">보험금 신청</a>
                      <a @click="modalOpen2('exchange')">보험금 환전</a>
                   </li>
                </ul>
             </li>
          </ul> -->
       </div>
      <div v-if="!loadError" class="chartwrap">
        <div class="chart">
          <h3>{{ $t('table.head.deWith') }}</h3>
          <p v-if="!hasGraph" class="chart-empty">{{ loading ? '불러오는 중입니다.' : '집계된 입출금 내역이 없습니다.' }}</p>
          <div v-else>
            <vue-apex-charts height="350" type="bar" :options="chartOptions1" :series="series1"></vue-apex-charts>
          </div>
        </div>
        <div class="chart">
          <h3>{{ $t('table.head.betWin') }}</h3>
          <p v-if="!hasGraph" class="chart-empty">{{ loading ? '불러오는 중입니다.' : '집계된 베팅 내역이 없습니다.' }}</p>
          <div v-else>
            <vue-apex-charts height="350" type="bar" :options="chartOptions2" :series="series2"></vue-apex-charts>
          </div>
        </div>
        <div class="chart">
          <h3>{{ $t('table.head.uAmt') }}/{{ $t('table.head.uPT') }}</h3>
          <p v-if="!hasGraph" class="chart-empty">{{ loading ? '불러오는 중입니다.' : '집계된 보유금 내역이 없습니다.' }}</p>
          <div v-else>
            <vue-apex-charts height="350" type="bar" :options="chartOptions3" :series="series3"></vue-apex-charts>
          </div>
        </div>
      </div>
     </div>
   </section>
</template>

<script>
import VueApexCharts from 'vue3-apexcharts'
import { getDashboard } from '@/api/common'
import { thousand } from '@/libs/utils'

const dashboardFields = ['inCashAmt', 'outCashAmt', 'beneAmt', 'memJoinCnt', 'betAmt', 'winAmt', 'winLoseAmt', 'betCnt']

function dashboardRow (source = {}) {
  const row = {}
  for (const key of dashboardFields) {
    row[key] = Number(source?.[key]) || 0
    row[key + 'Str'] = thousand(Math.abs(row[key]).toString())
  }
  return row
}

export default {
  name: 'MainDashboard',
  components: {
    VueApexCharts
  },
  data: function () {
    return {
      dashInfo: [dashboardRow(), dashboardRow()],
      diffDashInfo: dashboardRow(),
      loading: false,
      loadError: false,
      hasSummary: false,
      hasGraph: false,
      series1: [{
        name: '입금',
        data: []
      }, {
        name: '출금',
        data: []
      }],
      series2: [{
        name: '베팅금',
        data: []
      }, {
        name: '당첨금',
        data: []
      }],
      series3: [{
        name: '유저 보유금',
        data: []
      }, {
        name: '유저 보유포인트',
        data: []
      }],
      chartOptions1: {
        theme: {
          mode: 'dark'
        },
        labels: [],
        chart: {
          height: 350,
          zoom: {
            enabled: false
          },
          background: 'transparent'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          colors: ['#008FFB', '#00E396'],
          curve: 'straight',
          width: 2
        },
        title: {
          text: '',
          align: 'left'
        },
        tooltip: {
          y: {
            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
              return thousand(value)
            }
          }
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return thousand(value)
            }
          }
        }
      },
      chartOptions2: {
        theme: {
          mode: 'dark'
        },
        labels: [],
        colors: ['#DC84F3', '#EF4040'],
        chart: {
          height: 350,
          zoom: {
            enabled: false
          },
          background: 'transparent'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          colors: ['#DC84F3', '#EF4040'],
          curve: 'straight',
          width: 2
        },
        markers: {
          colors: ['#DC84F3', '#EF4040']
        },
        title: {
          text: '',
          align: 'left'
        },
        tooltip: {
          y: {
            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
              return thousand(value)
            }
          }
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return thousand(value)
            }
          }
        }
      },
      chartOptions3: {
        theme: {
          mode: 'dark'
        },
        labels: [],
        colors: ['#FF9843', '#638889'],
        chart: {
          height: 350,
          zoom: {
            enabled: false
          },
          background: 'transparent'
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          colors: ['#FF9843', '#638889'],
          curve: 'straight',
          width: 2
        },
        markers: {
          colors: ['#FF9843', '#638889']
        },
        title: {
          text: '',
          align: 'left'
        },
        tooltip: {
          y: {
            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
              return thousand(value)
            }
          }
        },
        yaxis: {
          labels: {
            formatter: function (value) {
              return thousand(value)
            }
          }
        }
      }
    }
  },
  methods: {
    async loadData () {
      if (this.loading) return
      this.loading = true
      this.loadError = false
      try {
        const { data: result } = await getDashboard({})
        if (result?.resultCode !== '0') throw new Error('Dashboard request failed')
        const rows = Array.isArray(result.data?.dashInfo) ? result.data.dashInfo : []
        this.hasSummary = rows.some(row => row && Object.keys(row).length > 0)
        this.dashInfo = [dashboardRow(rows[0]), dashboardRow(rows[1])]
        const difference = {}
        for (const key of dashboardFields) {
          difference[key] = this.dashInfo[0][key] - this.dashInfo[1][key]
        }
        this.diffDashInfo = dashboardRow(difference)

        const graph = Array.isArray(result.data?.graphInfo) ? result.data.graphInfo.filter(Boolean) : []
        this.hasGraph = graph.length > 0
        for (const [index, fields] of [['inCashAmt', 'outCashAmt'], ['betAmt', 'winAmt'], ['cashAmt', 'pointAmt']].entries()) {
          this['chartOptions' + (index + 1)].labels = graph.map(row => row.days)
          this['series' + (index + 1)] = fields.map((field, seriesIndex) => ({
            name: this['series' + (index + 1)][seriesIndex].name,
            data: graph.map(row => Number(row[field]) || 0)
          }))
        }
      } catch (error) {
        this.loadError = true
      } finally {
        this.loading = false
      }
    }
  },
  watch: {
  },
  computed: {
  },
  async created () {
    this.loadData()
  }
}
</script>

<style scoped>
.end {display: flex;justify-content: end;}
.main-contents-wrapper{width: 100%; box-sizing: border-box;}
.dashtext {font-size: 12px;margin-bottom: 29px;line-height: 1.5em;}
.dashboard-status {padding: 16px;margin-bottom: 20px;background: #1f2937;border: 1px solid #313a49;border-radius: 5px;color: #cbd5e1;font-size: 14px;}
.dashboard-status button {margin-left: 12px;padding: 6px 12px;background: #2f78ee;color: #fff;border-radius: 4px;cursor: pointer;}
.chart-empty {padding: 60px 16px;text-align: center;color: #cbd5e1;font-size: 14px;}
.dashwrap {display: flex;gap: 15px;flex-direction: column;width: 100%; min-width: 1100px;}
.dashth {display: flex;gap: 15px;flex-wrap: wrap; width: 100%;}
.dashth em {width: 39px;height: 43px;display: flex;align-items: center;justify-content: center;}
.dashth em img {height: 26px;}
.dashth > li {box-sizing: border-box;width: calc(25% - 12px);height: 140px;border-radius: 5px 5px 0 0;position: relative;background-color: #1f2937; }
.dashth > li.inout {border-top: 7px solid #fe964a; }
.dashth > li.bet {border-top: 7px solid #00a76d;}
.dashth > li.new {border-top: 7px solid #8c62ff;}
.dashlist li:first-child {background: #253141; height: 49px; border-bottom: 1px solid #313a49; font-size: 17px; font-weight: 600; display: flex; align-items: center; }
.dashth .open {position: absolute;right: 15px;top: 15px;cursor: pointer;}
/* .dashlist {} */
/* .dashlist li:first-child {margin-top: 0;margin-bottom: 8px;font-size: 16px;color: #000;} */
.dashlist li {padding: 7px 16px;display: flex;justify-content: space-between; font-size: 13px;color: #aaa;}
.dashlist li:nth-child(2) {font-size: 15px; padding-top: 15px;}
.bgrd {background: url('~@/assets/img/bg_rd.svg');}
.bgyw {background: url('~@/assets/img/bg_yw.svg');}
.bggn {background: url('~@/assets/img/bg_gn.svg');}
.bgbl {background: url('~@/assets/img/bg_bl.svg');}
.dashlist .btnwrap {display: flex;gap: 13px;margin-top: 8px;}
.btnwrap a {width: 100%;height: 25px;display: flex;align-items: center;justify-content: center;background-color: #353535;font-size: 13px;cursor: pointer;color: #fff;}
.chartwrap {
  margin-top:50px;
  display: flex;
  gap: 20px;
  width: 100%;
  position: relative;
}
.chart {
  width: calc(33.33% - 15px);
  display: flex;
  flex-direction: column;
  gap: 20px;
  border: 1px solid #313a49;
  border-top: 7px solid #2f78ee;
  border-radius: 5px 5px 0 0;
  box-sizing: border-box;
}
.chart h3 {
  padding: 7px 16px;
  background: #253141;
  height: 49px;
  border-bottom: 1px solid #313a49;
  font-size: 17px;
  font-weight: 600;
  display: flex;
  align-items: center;
  color: #aaa;
}
.chart > div {
  padding: 10px;
  padding-top: 0;
}
.apexcharts-menu {background: #1f2937 !important;}

@media (max-width: 1092px) {
  .chart {width: 100%;}
}
</style>
